module.exports = __webpack_public_path__ + "static/f11_1-f08a4d1d51686a38db2162a7c6c3a608.jpeg";